const position = {
  babbar: {
    array: 0,
    matrix: 1,
    string: 2,
    searchingsorting: 3,
    linkedlist: 4,
    binarytrees: 5,
    bst: 6,
    greedy: 7,
    backtracking: 8,
    stacksqueues: 9,
    heap: 10,
    graph: 11,
    trie: 12,
    dynamicprogramming: 13,
    bitmanipulation: 14,
  },
  striver: {
    array: 0,
    linkedlist: 1,
    string: 2,
    greedyalgorithm: 3,
    binarytrees: 4,
    bst: 5,
    binarysearch: 6,
    recursionbacktracking: 7,
    stacksqueues: 8,
    heap: 9,
    graph: 10,
    trie: 11,
    dynamicprogramming: 12,
  },
  apnaCollege: {
    array: 0,
    strings: 1,
    matrix: 2,
    searchingsorting: 3,
    linkedlist: 4,
    binarytrees: 5,
    bst: 6,
    greedy: 7,
    backtracking: 8,
    stacksqueues: 9,
    heapandhashing: 10,
    graph: 11,
    trie: 12,
    dynamicprogramming: 13,
    bitmanipulation: 14,
    segmenttrees: 15,
  },
};

export default position;
